import { render } from "./sharedComponent.vue?vue&type=template&id=149fa7b8"
import script from "./sharedComponent.vue?vue&type=script&lang=js"
export * from "./sharedComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__